import { render, staticRenderFns } from "./FlagIcons.vue?vue&type=template&id=1df1857c&scoped=true&"
import script from "./FlagIcons.vue?vue&type=script&lang=js&"
export * from "./FlagIcons.vue?vue&type=script&lang=js&"
import style0 from "./FlagIcons.vue?vue&type=style&index=0&id=1df1857c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df1857c",
  null
  
)

export default component.exports